// i18n area 'cluster' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.ro-RO.meta.json.
import type { enUS } from './cluster'

export const roRO: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Accese de garanție',
      subtitle: 'Ușa de serviciu a nodului: accesul doar în citire cu parolă temporară și contul de urgență cu parola din seif',
      readOnlyTitle: 'Acces doar în citire (trantor)',
      stateNone: 'închis',
      stateGranted: 'deschis',
      stateGrantedPending: 'acordat — se aplică pe nod',
      grantedBy: 'Acordat de',
      grantedAt: 'Acordat la',
      expiresAt: 'Expiră la',
      reason: 'Motiv',
      endedAt: 'Închis',
      endedReason: {
        revoked: 'revocat',
        expired: 'expirat (TTL)',
        reboot: 'repornirea nodului',
        failed: 'neaplicat (sarcina a eșuat)'
      },
      grant: 'Acordă acces doar în citire…',
      grantTitle: 'Acordă acces doar în citire',
      grantSubmit: 'Acordă',
      grantError: 'Acordarea a fost refuzată',
      grantConfirm: 'TVirt generează o parolă temporară pentru utilizatorul de sistem «trantor» (doar citire: journal și diagnostic, fără sudo) și o setează pe nod printr-o sarcină. Parola este afișată O SINGURĂ dată, la confirmare; încetează la expirare, la revocare sau la următoarea repornire a nodului.',
      reasonLabel: 'Motiv',
      reasonHint: 'De ce deschizi ușa: rămâne în acordare, în audit și în jurnal',
      ttlLabel: 'Durată',
      ttlHours: '{n} h',
      revoke: 'Revocă accesul doar în citire…',
      revokeTitle: 'Revocă accesul doar în citire',
      revokeSubmit: 'Revocă',
      revokeError: 'Revocarea a fost refuzată',
      revokeConfirm: 'Acordarea încetează imediat și o sarcină blochează din nou utilizatorul «trantor» pe nod: parola temporară nu mai este valabilă.',
      passwordTitle: 'Parolă doar în citire',
      passwordOnce: 'Această parolă este afișată O SINGURĂ dată: copiaz-o acum. Nu este salvată nicăieri și nu va putea fi recitită — dacă o pierzi, acordă din nou.',
      passwordUser: 'Utilizator',
      passwordLabel: 'Parolă',
      passwordHint: 'Valabilă până la {until} sau până la următoarea repornire a nodului; utilizabilă când sarcina de acordare s-a încheiat. Acces: ssh trantor@<adresa nodului>.',
      emergencyTitle: 'Ultimul acces de urgență (trantor-emergency)',
      lastLogin: '{time} prin {via} de la {from}',
      lastLoginNone: 'niciunul observat',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'consolă',
        sudo: 'sudo',
        unknown: 'necunoscut'
      },
      emergencyHint: 'Contul de urgență «trantor-emergency» (sudo complet) este întotdeauna activ cu parola generată la instalarea nodului și păstrată în seif: TVirt nu o cunoaște, nu o rotește și nu o recuperează. Fiecare autentificare este raportată aici și în jurnalul de evenimente.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall-ul nodurilor',
      subtitle: 'Postura ruleset-ului nftables pe care fiecare nod și-l aplică sieși — singurul firewall al unui nod (firewalld este dezactivat)',
      modeLabel: 'Postură',
      mode: {
        disabled: 'Dezactivat — niciun ruleset pe noduri',
        permissive: 'Permisiv — numără și înregistrează, nu aruncă nimic',
        enforced: 'Aplicat — intră doar registrul derivat'
      },
      hint: {
        disabled: 'Ca astăzi: nodurile nu poartă niciun ruleset. Treci pe permisiv ca să CITEȘTI ce ar fi aruncat înainte să fie aruncat.',
        permissive: 'Fiecare nod își aplică ruleset-ul derivat cu policy accept: ceea ce modul aplicat ar arunca este numărat și înregistrat (prefix de journal «tvirt-node would-drop:»). Nimic nu este blocat.',
        enforced: 'Fiecare nod își aplică ruleset-ul derivat cu policy drop: ssh și API de oriunde, store / live migration / overlay / Ceph doar de la membri, listenerii serviciilor de rețea din rețeaua deservită. Fiecare schimbare este un apply cu confirmare — un nod care nu reușește să confirme revine singur.'
      },
      confirmTitle: 'Aplici firewall-ul nodurilor?',
      confirmBody: 'Fiecare nod aplică ruleset-ul cu confirmare: sondează backend-ul, store-ul și ssh prin noile reguli înainte de termen și confirmă — altfel revine singur la ruleset-ul anterior. Citește mai întâi contoarele modului permisiv de pe noduri.',
      confirmSubmit: 'Aplică',
      confirmCancel: 'Anulează',
      lensTitle: 'Firewall-ul nodului',
      loadError: 'Nu s-a putut încărca lentila firewall-ului nodului',
      noReport: 'Încă niciun raport de firewall de la acest nod — workerul raportează la următoarea trecere',
      firewalldActive: 'Pe acest nod rulează firewalld: firewall-ul de nod refuză să se aplice alături de el (maschează firewalld)',
      conditionUnconfirmed: 'Încă niciun ruleset confirmat — nodul este deschis',
      conditionRolledBack: 'Ultimul apply a făcut rollback — aceeași generație nu se reîncearcă până când registrul nu se schimbă sau postura nu este schimbată din nou',
      lastError: 'Ultima eroare',
      posture: 'Postură',
      observedAt: 'Observat',
      desiredGeneration: 'Generație dorită',
      componentTitle: 'Componentă de nod',
      componentSubtitle: 'tvirt-node-firewall — aplică la boot ruleset-ul confirmat, face singur rollback la unul neconfirmat',
      componentAbsent: 'Componenta nu a raportat încă',
      phase: 'Fază',
      phases: {
        none: 'Niciodată aplicat',
        applied: 'Aplicat — în așteptarea confirmării',
        confirmed: 'Confirmat',
        rolledBack: 'Rollback efectuat'
      },
      generation: 'Generație',
      appliedAt: 'Aplicat la',
      confirmedAt: 'Confirmat la',
      deadline: 'Termen de rollback',
      lastRollback: 'Ultimul rollback',
      registryTitle: 'Registru derivat',
      registrySubtitle: 'Porturile pe care le deschide acest nod, pe clasă și origine — derivate din cluster, niciodată modificate manual',
      registryEmpty: 'Nimic derivat — postură dezactivată fără ruleset confirmat, sau încă niciun raport',
      colClass: 'Clasă',
      colPort: 'Port',
      colSource: 'Sursă',
      colOrigin: 'Origine',
      classes: {
        public: 'Publică',
        internode: 'Inter-nod',
        tenant: 'Tenant'
      },
      sourceMembers: 'doar membrii',
      sourceAnywhere: 'de oriunde',
      sourceBridge: 'pe {iface}'
    },
    derivationDerived: 'derivat',
    derivationDiverged: 'divergent',
    derivationDerivedTip: 'Documentul de rețea este DERIVAT din fabric-ul {fabric} și încă coincide cu render-ul pe intrările curente — clic pentru planul de derivare.',
    derivationDivergedTip: 'Derivarea din fabric-ul {fabric} s-a schimbat după ultimul apply (fabric, cablare, roluri sau referințe) — clic pentru diff-ul în așteptare.',
    derivationRetiring: {
      one: '{n} adresă în drenare',
      few: '{n} adrese în drenare',
      other: '{n} de adrese în drenare'
    },
    standaloneHint: 'Acest nod nu are cluster: nu a fost încă instalat. Un cluster se creează SAU se face join în el la instalare — tokenul generat din tabelul Servere al unui membru i se dă installerului (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Permisiunile tale acoperă un scope, nu întregul cluster: inventarul flotei — noduri, setări și dispozitive — este vizibil doar celor care administrează clusterul.',
    phaseReady: 'Gata',
    phaseForming: 'În formare',
    storeMembers: 'Membrii store-ului',
    watermark: 'Prag de convergență',
    configGeneration: 'Generație de config',
    converged: 'aliniat',
    behind: 'în urmă — {m} / {n}',
    revision: 'Revizie',
    rolesTitle: 'Roluri de rețea',
    rolesSubtitle: 'Adrese pe membru pentru fiecare clasă de trafic — conectivitatea trăiește în rețeaua hostului',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'moștenește managementul',
    settingsTitle: 'Setări',
    settingsSubtitle: 'Politica de securitate la nivel de cluster — evaluată de fiecare nod din replica sa locală',
    taskRetentionTitle: 'Retenție taskuri',
    taskRetentionSubtitle: 'GC unificat pentru toate taskurile — taskurile încheiate care depășesc vârsta sau plafonul sunt colectate, niciodată cele în curs',
    taskRetentionMaxAge: 'Vârsta maximă (zile)',
    taskRetentionMaxCount: 'Număr maxim de taskuri',
    eventRetentionTitle: 'Retenția evenimentelor',
    eventRetentionSubtitle: 'GC-ul jurnalului — o politică independentă de cea a sarcinilor: sarcina e o coadă, evenimentul e memorie',
    eventRetentionMaxAge: 'Vârsta maximă (zile)',
    eventRetentionMaxCount: 'Numărul maxim de evenimente',
    spaceThresholdsTitle: 'Praguri de spațiu',
    spaceThresholdsSubtitle: 'Când un stocator care se umple ajunge în jurnal (și în notificări)',
    spaceLowPct: 'Avertisment de la (% folosit)',
    spaceCriticalPct: 'Critic de la (% folosit)',
    spaceOrderError: 'Criticul nu poate sta sub avertisment',
    spaceThresholdsHint: 'Se configurează doar intrările: ieșirea o derivă motorul, 5 puncte sub fiecare prag, ca un stocator oprit pe linie să nu devină niciodată un metronom',
    failoverReserveTitle: 'Rezervă de failover',
    failoverReserveSubtitle: 'Admission control N+1 — RAM păstrat liber pentru ca clusterul să își poată reporni sarcina de lucru după pierderea unor noduri',
    failoverReserveTolerate: 'Pierderi de noduri de tolerat',
    failoverReserveOff: '0 — rezerva este dezactivată: nicio pornire nu este refuzată vreodată pentru capacitate de failover',
    failoverReserveOn: 'O pornire care ar știrbi rezerva este refuzată cu un 412 care explică cifrele',
    networkShapingTitle: 'Echitatea lățimii de bandă',
    networkShapingSubtitle: 'Cele trei ponderi pe tipologie ale arborelui de shaping per uplink — acționează doar în caz de contenție',
    networkShapingRest: 'Ponderea restului (planul de control, storage, replici)',
    networkShapingOverlay: 'Ponderea rețelelor overlay',
    networkShapingLiveMigration: 'Ponderea live migration',
    networkShapingHint: 'Cota garantată = pondere / suma celor trei (implicit 300 / 100 / 200, fiecare de la 1 la 10000); pe o legătură liberă orice clasă poate lua toată lățimea de bandă',
    debugModeTitle: 'Mod debug',
    debugModeSubtitle:
      'Erori detaliate în alertele generice ale GUI-ului — ca să vezi cauza reală atunci când o acțiune „eșuată” de fapt a reușit',
    debugModeLabel: 'Mod debug activat',
    debugModeOn: 'Alertele de eroare generice adaugă cauza de bază — detalii interne vizibile pentru fiecare operator',
    debugModeOffHint: 'Dezactivat — alertele de eroare generice rămân generice, fără detalii interne',
    nodeDetailsAction: 'Detalii nod',
    node: {
      docTitle: 'Nod',
      notFound: 'Nodul nu a fost găsit',
      tabOverview: 'Prezentare generală',
      tabStats: 'Statistici',
      tabNetwork: 'Rețea',
      tabSettings: 'Setări locale',
      identityTitle: 'Identitate',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'Port YSQL',
      revision: 'Revizie config',
      versionsTitle: 'Versiuni observate',
      heartbeatSubtitle: 'Ultima stare pe care nodul a raportat-o despre sine',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Model CPU',
      memoryTitle: 'Memorie',
      hugePagesTitle: 'Pagini uriașe',
      hugePagesPool: '{size}: {free} libere din {total}',
      hugePagesNone: 'Niciun pool',
      hugePagesNoneHint: 'Nodul nu are pagini uriașe rezervate: VM-urile care cer așa ceva nu pot porni aici. Pool-ul se declară pe nod, cu parametrii de kernel hugepagesz și hugepages sau scriind nr_hugepages.',
      usageTitle: 'Utilizare curentă',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'neobservat — niciun eșantion proaspăt',
      statsNoData: 'Nu există date în interval — seriile nodului sunt eșantionate de nodul însuși și servite local.',
      observedTitle: 'Stare observată',
      observedSubtitle: 'Serviciile și asseturile locale nodului, așa cum le vede workerul'
    },
    editRolesTitle: 'Modifică rolurile de rețea',
    memberNode: 'Nod',
    memberIp: 'Adresă IP',
    addMember: 'Adaugă membru',
    lmInherit: 'Folosește adresele de management',
    roleIpHint: 'Adăugarea și eliminarea membrilor este liberă; schimbarea pe loc a IP-ului unui membru existent este refuzată — fluxul de migrare a IP-ului sosește într-un round ulterior.',
    roleError: 'Nu s-au putut actualiza rolurile',
    nodesTitle: 'Noduri',
    addNodeTitle: 'Adaugă nod în cluster',
    addNode: 'Adaugă nod',
    addNodeError: 'Nu s-a putut preînregistra nodul',
    nodeName: 'Numele nodului',
    nodeNameHint: 'trebuie să coincidă cu numele ales la instalare',
    nodeIp: 'IP de management',
    colName: 'Nume',
    colPhase: 'Fază',
    colServices: 'Servicii',
    colWatermark: 'Watermark',
    colLastSeen: 'Ultimul contact',
    colUps: 'UPS',
    upsCordonChip: 'cordon UPS',
    upsCordonTip: 'Nodul s-a condamnat pe baza faptelor UPS-ului său ({time}): ridică singur cordonul când rețeaua e stabilă și bateria reîncărcată',
    upsUnreachable: 'UPS inaccesibil',
    upsOnBattery: 'Pe baterie',
    upsOnLine: 'Pe rețea',
    upsLowBattery: 'baterie descărcată',
    upsNoEstimateChip: 'autonomie neestimată',
    upsNoEstimateTip: 'UPS-ul nu publică estimarea autonomiei: nodul e condamnat doar de indicatorul LB (baterie descărcată) al UPS-ului — reglați battery.runtime.low / LB pe UPS',
    upsLaneTip: 'Cale de oprire UPS din {since}: condamnat de {by}',
    upsUnit: 'unitate',
    upsStatus: 'stare NUT',
    upsLoad: 'sarcină',
    upsOnBatterySince: 'pe baterie din',
    upsOnLineSince: 'pe rețea din',
    upsError: 'eroare',
    upsObservedAt: 'observat',
    upsNone: 'nicio unitate UPS nu deservește acest nod',
    upsBy: {
      runtime: 'autonomie sub prag',
      lowBattery: 'indicatorul LB al UPS-ului',
    },
    upsLane: {
      evacuate: 'evacuare',
      local: 'oprire pe loc',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'oprirea oaspeților',
      stoppingServices: 'oprirea serviciilor',
      poweredOff: 'oprit',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'Unități UPS și praguri: nod condamnat la autonomie ≤ prag sau indicator LB (întotdeauna respectat), reluare cu histerezis',
    upsRuntimeThreshold: 'Prag de autonomie (s)',
    upsRuntimeThresholdHint: 'Pe baterie, cu autonomie estimată ≤ prag nodul se oprește în ordine (implicit 300)',
    upsResumeStable: 'Rețea stabilă timp de (s)',
    upsResumeStableHint: 'Reluare doar cu rețea continuă de cel puțin atâtea secunde (implicit 60)',
    upsResumeCharge: 'Încărcare minimă la reluare (%)',
    upsResumeChargeHint: 'Și baterie reîncărcată cel puțin la acest procent (implicit 25)',
    upsPolicyNote: 'Indicatorul LB (baterie descărcată) al UPS-ului condamnă întotdeauna și nu se dezactivează; nu există prag pe timpul petrecut pe baterie. Fiecare unitate poate suprascrie cele trei numere.',
    upsUnitNew: 'unitate nouă',
    upsUnitSelectors: '{n} selector(i) după etichete (doar CLI)',
    upsUnitName: 'Numele unității',
    upsUnitMode: 'Mod',
    upsModeExternal: 'externă (upsd străin)',
    upsModeManaged: 'gestionată (UPS conectat la un nod)',
    upsUnitUpsname: 'Nume NUT (upsname)',
    upsUnitHost: 'Gazdă upsd',
    upsUnitAttachedNode: 'Nod conectat',
    upsUnitDriver: 'Driver NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Dispozitivul driverului',
    upsUnitDeviceHint: 'linia port= din ups.conf: gol = auto',
    upsUnitPort: 'Port upsd',
    upsUnitServedNodes: 'Noduri deservite',
    upsUnitServedNodesHint: 'numele nodurilor separate prin virgulă (selectorii după etichete trec prin CLI)',
    upsUnitOverrideHint: 'gol = implicit al clusterului',
    upsUnitAdd: 'Adaugă unitate',
    unreachableSince: 'Inaccesibil — ultimul heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Dataplane-ul overlay nu a realizat încă configurația overlay curentă',
    overlaysError: 'Ultima trecere de reconciliere overlay a eșuat: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'În așteptarea join-ului',
      'joining': 'În aderare',
      'member': 'Membru'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Afișat doar acum — copiază-l imediat, nu va mai putea fi citit niciodată',
    copy: 'Copiază',
    copied: 'Copiat',
    close: 'Închide',
    revokeTitle: 'Revocă preînregistrarea',
    revoke: 'Revocă',
    revokeError: 'Nu s-a putut revoca înregistrarea',
    promote: 'Promovează la store member',
    demote: 'Elimină rolul store-member',
    troubleshoot: 'Depanare',
    promoteTitle: 'Promovează la store member',
    demoteTitle: 'Elimină rolul store-member',
    promoteHint: 'Nodul intră în cvorumul masterilor YugabyteDB. HA reală cere trei store members.',
    demoteHint: 'Nodul iese din cvorumul masterilor și își oprește serviciile de store.',
    storeError: 'Modificarea de store-member a fost refuzată',
    attest: 'Atestă stins…',
    attestTitle: 'Atestă nodul stins',
    attestSubmit: 'Atestă stins',
    attestConfirm: 'Declari acest nod stins, pe riscul tău: atestarea unui nod în realitate viu riscă VM-uri în execuție dublă. Taskurile lui sunt marcate eșuate, iar Authority-urile VM-urilor lui devin transferabile.',
    attestError: 'Atestarea a fost refuzată',
    attestedChip: 'atestat stins',
    maintenanceChip: 'mentenanță',
    guestToolsChip: 'TVirt Guest Tools (asset ISO local al nodului)',
    maintenanceEnter: 'Activează mentenanța',
    maintenanceExit: 'Dezactivează mentenanța',
    maintenanceEnterTitle: 'Activează mentenanța',
    maintenanceExitTitle: 'Dezactivează mentenanța',
    maintenanceEnterSubmit: 'Activează mentenanța',
    maintenanceExitSubmit: 'Dezactivează mentenanța',
    maintenanceEnterConfirm: 'Nodul este izolat și golit: serviciile de rețea și instanțele App a căror authority o deține sunt transferate (instanțele la rece: oprite și secerate aici, recreate pe nodul țintă — întrerupere), VM-urile pornite sunt migrate live unde este posibil și oprite ordonat altfel, sarcinile în curs se termină, lucrul nou așteaptă, iar VM-urile oprite își pierd authority — Proximity le repoziționează la următoarea pornire. Nimic nu revine singur la sfârșitul mentenanței.',
    maintenanceExitConfirm: 'Nodul reia lucrul, iar Proximity îl ia din nou în calcul pentru plasare. VM-urile revin doar când sunt pornite.',
    maintenanceError: 'Cererea de mentenanță a fost refuzată',
    maintenancePlanTitle: 'Plan de evacuare',
    maintenancePlanLoading: 'Se calculează planul de evacuare…',
    maintenancePlanError: 'Nu s-a putut încărca planul de evacuare — drain-ul va migra oricum unde se poate și va opri restul.',
    maintenancePlanEmpty: 'Nimic de evacuat pe acest nod — niciun serviciu de rețea activ, nicio instanță App dorită în execuție, nicio VM pornită.',
    maintenancePlanSummary: '{migrate} obiecte vor migra (VM-uri, servicii de rețea, instanțe App), {stop} se vor opri sau vor rămâne pe loc.',
    maintenancePlanReserve_ok: 'Rezerva de failover după golire: intactă — rămân {headroom} GiB pornibili, cu pierderea tolerată de noduri: {n}.',
    maintenancePlanReserve_eroded: 'Rezerva de failover după golire: aproape consumată — au mai rămas doar {headroom} GiB din {reserve} GiB păstrați liberi pentru defecțiuni de nod: {n}.',
    maintenancePlanReserve_exhausted: 'Rezerva de failover după golire: EPUIZATĂ — lipsesc {headroom} GiB din {reserve} GiB necesari pentru a tolera defecțiuni de nod: {n}. Cât timp acest nod este scos, pornirile noi de VM vor fi refuzate.',
    maintenancePlanReserve_unknown: 'Rezerva de failover după golire: nu poate fi calculată — niciun nod rămas nu și-a declarat memoria.',
    maintenancePlanReserveHugePages: 'Pagini uriașe de {size} după golire — libere: {free} din {capacity}, cerute ca rezervă: {reserve}.',
    maintenancePlanActionMigrate: 'migrează',
    maintenancePlanActionMigrateWarning: 'migrează (regulă soft încălcată)',
    maintenancePlanActionStop: 'se oprește',
    maintenancePlanActionBlocked: 'blocată',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'serviciu de rețea',
    maintenancePlanKindApp: 'instanță App',
    maintenancePlanColdMove: 'Mutare la rece: podul este oprit și secerat aici și recreat pe nodul țintă de worker-ul său — întrerupere până la următorul pass al worker-ului țintă.',
    caFingerprint: 'Fingerprintul CA al clusterului',
    staleChip: 'neactualizat',
    troubleshootTitle: 'Depanarea store-ului',
    restartStore: 'Repornește serviciile store',
    restartHint: 'Dacă store-ul face nazuri, repornește-i serviciile. Avansat — de folosit cu grijă.',
    restartQueued: 'Task de repornire pus în coadă',
    restartError: 'Nu s-au putut reporni serviciile',
    svcActive: 'activ',
    svcWanted: 'dorit, nepornit',
    svcStopped: 'oprit',
    noServices: 'Niciun serviciu raportat'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Inventarul GPU al întregului cluster, grupat pe model — plăcile observate pe nod, cu înregistrările marcate și tagurile lor',
    usbTitle: 'Resurse USB',
    usbSubtitle: 'Inventarul USB al întregului cluster, grupat pe model — dispozitivele observate pe nod, cu înregistrările ambelor modele (pe dispozitiv, pe port) și tagurile lor',
    markedChip: 'utilizabile de TVirt: {n}',
    orphanChipGpu: 'orfane: {n}',
    orphanChipUsb: 'orfane: {n}',
    colNode: 'Nod',
    colRegistration: 'Înregistrare',
      noRegsHint: 'Nicio înregistrare — dispozitivul se marchează „utilizabil de TVirt” din dialogul nodului (Noduri › nod › Setări).',
      colDevice: 'Dispozitiv',
      colObserved: 'Observate',
      colRegs: 'Înregistrări',
      regsNone: 'niciuna',
      colPci: 'Adresă PCIe',
      colIdentity: 'Identitate / port',
      colClasses: 'Clase (taguri)',
      colActions: 'Acțiuni',
      manageOnNode: 'Gestionează pe nodul {node} (marcarea trăiește în dialogul nodului)',
      introTitle: 'Inventarul de cluster al dispozitivelor USB și PCIe utilizabile de TVirt©.',
      introStep1: '1. Nodurile își descoperă singure GPU-urile și dispozitivele USB (recensământ în heartbeat).',
      introStep2: '2. Un dispozitiv se marchează „utilizabil de TVirt” din dialogul NODULUI (Noduri › nod › Setări) — marcarea îl leagă la vfio și îl înregistrează aici.',
      introStep3: '3. Aici dai înregistrărilor CLASELE lor prin taguri (ex. gpu_class=compute): cerințele VM-urilor vor cere o clasă, iar schedulerul va alege un nod cu un dispozitiv liber compatibil.',
    colMode: 'Mod',
    colState: 'Stare',
    colNotes: 'Note',
    colTags: 'Taguri',
    modeDevice: 'pe dispozitiv',
    modePort: 'pe port',
    usable: 'utilizabil',
    orphanGpu: 'orfană',
    orphanUsb: 'orfan',
    hubChip: 'hub',
    orphanPortsTitle: 'Înregistrări pe port fără niciun dispozitiv conectat — reconectează un dispozitiv sau demarchează-le din nod',
    gpusEmpty: 'Nicio GPU observată încă pe vreun nod',
    usbEmpty: 'Niciun dispozitiv USB observat încă pe vreun nod'
  },
  settings: {
    passwordMinLength: 'Lungimea minimă a parolei',
    sessionIdle: 'Timeout de inactivitate a sesiunii (minute)',
    lockoutThreshold: 'Blocare după încercări eșuate',
    lockoutDuration: 'Durata blocării (minute)',
    keyboardLayout: 'Layout de tastatură',
    keyboardLayoutHint: 'ex. it, en-us — gol pentru valoarea implicită QEMU',
    syslogEndpoint: 'Endpoint syslog',
    syslogEndpointHint: 'host:port — gol pentru a dezactiva redirecționarea',
    syslogTls: 'TLS',
    maxQueued: 'Maxim de taskuri în coadă',
    concurrency: 'Concurența workerului',
    concurrencyHint: 'Aplicată din mers de worker',
    notesTitle: 'Note',
    save: 'Salvează',
    saved: 'Setări salvate',
    saveError: 'Nu s-au putut salva setările'
  },
  localSettings: {
    derivedChip: 'derivat',
    derivedTip: 'Acest device este PROPRIETATEA derivării fabric (H2): editorul refuză să-l atingă — modificați fabric-ul (sau cablarea) și reaplicați, sau luați-l înapoi mai jos.',
    takeOwnership: 'Preia proprietatea',
    takeOwnershipTitle: 'Preia proprietatea (take-ownership)',
    takeOwnershipConfirm: '{name} părăsește blocul fabric și redevine un device MANUAL guvernat de acest editor. Nodul devine divergent, iar următorul apply al derivării va refuza pe el (manualConflict) până îl redenumiți sau eliminați — sau corectați fabric-ul.',
    nodeSettingsTitle: 'Setări nod',
    nodeSettingsSubtitle: 'Ceea ce aplică acest nod — coada de taskuri, consola, redirecționarea logurilor — plus tagurile și notele lui',
    baseTitle: 'Rezervări host (TVirt Proximity)',
    baseSubtitle: 'CPU și RAM rezervate sistemului de operare al hostului — inputurile capacității empirice cu care Proximity plasează VM-urile',
    baseMemory: 'RAM de bază (MiB)',
    baseMemoryHint: 'Total observat: {total} MiB. Utilizabil pentru VM-uri = total − bază − RAM-ul VM-urilor pornite plasate aici.',
    baseMemoryHintNoTotal: 'Utilizabil pentru VM-uri = total observat − bază − RAM-ul VM-urilor pornite plasate aici.',
    baseCpu: 'Core-uri CPU de bază',
    baseCpuHint: 'CPU logice observate: {total}. Folosite doar ca pondere de ranking — overcommitul de vCPU este normal.',
    baseCpuHintNoTotal: 'Folosite doar ca pondere de ranking — overcommitul de vCPU este normal.',
    baseHint: 'RAM-ul este poarta strictă de admisie: o VM care nu încape în RAM-ul utilizabil este refuzată cu o eroare grăitoare. Ridică baza pe hosturile care găzduiesc membri ai store-ului sau demoni Ceph.',
    placementTitle: 'Amplasare fizică',
    placementSubtitle: 'Unde stă fizic acest server — declarat o singură dată, orice ar servi',
    placementHint: 'Amplasarea ghidează ierarhia CRUSH a fiecărui cluster Ceph cu un OSD pe acest server: salvarea unei modificări le realiniază hărțile printr-un task (host → rack → … → root). Declarațiile parțiale sunt legale — nivelurile goale pur și simplu colapsează. Numele sunt partajate pe întreaga hartă: două servere din același rack declară același nume de rack.',
    placementNameInvalid: 'Nume DNS-safe (litere mici, cifre, cratime)',
    placementEmpty: 'Gol = nedeclarat',
    placementLevel: {
      chassis: 'Șasiu',
      rack: 'Rack',
      row: 'Rând',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Sală',
      datacenter: 'Datacenter',
      zone: 'Zonă',
      region: 'Regiune'
    },
    cablingTitle: 'Cablare',
    cablingSubtitle: 'În ce port de switch este conectată fiecare interfață — declarația trăiește pe nod (Annex O.9)',
    cablingHint: 'Câte un cablu pe NIC, câte un cablu pe port în toată flota (API-ul refuză numind deținătorul). Cablarea către un port membru al unui LAGG este legală — este cazul bond: derivarea viitoare îl va reda ca LACP.',
    cablingInterface: 'Interfață',
    cablingNotCabled: '— necablată —',
    cablingNoInterfaces: 'Nicio interfață de rețea observată încă',
    disksTitle: 'Discuri',
    disksSubtitle: 'Dispozitivele bloc observate — o scanare la fiecare trecere de reconciliere; marchează aici discurile utilizabile ca OSD-uri Ceph (N.15: eligibilitatea este explicită)',
    colDataDisk: 'Disc de date',
    dataDisksHint: 'Bifarea unui dispozitiv îl declară utilizabil ca OSD; serialul este pinul lui de identitate — copiat din hardware când discul îl raportează, emis (tvirt-…) în caz contrar. Dialogul de înregistrare Ceph oferă doar discurile declarate.',
    diskDeclaredSerial: 'declarat',
    diskNotObserved: 'declarat, dar neobservat — reatașează dispozitivul sau debifează-l',
    noDisks: 'Niciun dispozitiv bloc observat încă',
    colSerial: 'Serial',
    colModel: 'Model',
    colSize: 'Dimensiune (GiB)',
    colDiskType: 'Tip',
    colInUse: 'În uz',
    colObservedAt: 'Observat',
    diskInUse: 'în uz',
    diskFree: 'liber',
    diskMounted: 'montat',
    diskPartitions: 'partiții',
    passthroughTitle: 'Dispozitive passthrough',
    passthroughSubtitle: 'GPU-urile și dispozitivele USB observate — marchează aici ce poate TVirt să paseze VM-urilor; marcarea înregistrează identitatea dispozitivului (round U1+G1)',
    passthroughHint: 'Marcarea înregistrează dispozitivul (un id stabil — ținta tagurilor și a cerințelor de clasă). O GPU marcată are ÎNTREGUL grup IOMMU legat la vfio-pci dintr-odată — părăsește imediat hostul; demarcarea reatașează driverul nativ. Pentru USB există ambele modele ratificate: pe dispozitiv (vendor+produs, oriunde ar fi conectat) și pe port fizic (VM-ul primește orice este băgat acolo). USB-ul nu face bind la marcare — attach-ul are loc la runtime-ul VM-ului.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Utilizabil de TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Adresă PCI',
    colDriver: 'Driver',
    colVerdict: 'Verdict',
    gpuEligible: 'Eligibilă',
    gpuIneligible: 'Neeligibilă',
    gpuReason: {
      'no-iommu': 'IOMMU inactiv pe host',
      'group-spans-slots': 'grup IOMMU neizolat: se întinde pe alte sloturi',
      'multiple-display': 'grup IOMMU neizolat: mai mult de o funcție video',
      'foreign-function': 'grup IOMMU neizolat: conține o funcție străină'
    },
    vfioNotReady: 'IOMMU nu este activ pe acest host: nicio GPU nu este eligibilă până când platforma host nu îl activează (ISO OEM) — TVirt nu retușează niciodată kernel args la runtime.',
    vfioMissingKernelArg: 'IOMMU nu este activ pe acest host: firmware-ul raportează VT-d/AMD-Vi (tabelă ACPI DMAR/IVRS prezentă), dar lipsește kernel arg-ul — adaugă intel_iommu=on (Intel) sau scoate amd_iommu=off (AMD) din linia de comandă a kernelului și repornește. TVirt nu retușează niciodată kernel args la runtime.',
    vfioFirmwareDisabled: 'IOMMU nu este activ pe acest host: VT-d/AMD-Vi este dezactivat în firmware (nicio tabelă ACPI DMAR/IVRS) sau CPU-ul nu are suport — activează-l din setup-ul firmware-ului, niciun kernel arg nu îl poate aprinde. TVirt nu retușează niciodată hostul la runtime.',
    gpuBindError: 'Bind vfio-pci eșuat pe {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Firewall pe bridge-uri negestionate',
    firewallBridgesSubtitle: 'Bridge-urile construite manual pe acest nod al căror setup consimte la chain-urile de firewall randate de TVirt pe NIC-urile de oaspete atașate',
    firewallBridgesHint: 'TVirt nu atinge niciodată bridge-ul străin — chain-ul se ancorează pe tap/veth, care e mereu al lui TVirt. Lista e o poartă de consimțământ: default-deny și anti-spoof pot strica ce așteaptă un setup manual, așa că un NIC cu firewall pe un bridge negestionat care NU e listat aici e refuzat cu o eroare grăitoare.',
    firewallBridgesEmpty: 'Niciun bridge negestionat nu consimte la chain-urile de firewall randate de TVirt pe acest nod.',
    firewallBridgeAdd: 'Adaugă bridge',
    firewallBridgeInvalid: 'Nu e un nume de interfață Linux (1-15 caractere, fără slash sau spații)',
    firewallBridgeDuplicate: 'Nume deja listat',
    colMarkDevice: 'Pe dispozitiv',
    colMarkPort: 'Pe port',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'orfan — înregistrat, dar nu mai este detectat: reconectează-l sau demarchează-l',
    noGpus: 'Nicio GPU observată încă',
    noUsb: 'Niciun dispozitiv USB observat încă',
    networkGeneration: 'Generație de rețea',
    applied: 'Aplicată',
    converged: 'aliniat',
    behind: 'în urmă — {m} / {n}',
    notConfigured: 'neconfigurat',
    rollbackBody: 'Aplicarea generației {gen} a eșuat: {error}',
    rolledBackChip: 'rollback efectuat',
    nicsTitle: 'NIC-uri',
    nicsSubtitle:
      'Evidența NIC-urilor gestionate — înregistrarea ESTE declarația de gestionare: o NIC înregistrată fără configurație nu este atinsă (clear-if o declară explicit curată), un dispozitiv neînregistrat nu este atins niciodată',
    addNic: 'Înregistrează NIC',
    addNicTitle: 'Înregistrează NIC (add-nic)',
    delNic: 'Încheie gestionarea',
    delNicTitle: 'Încheie gestionarea (del-nic)',
    delNicConfirm:
      'Gestionarea lui {name} se încheie: intrarea din evidență și configurația ei sunt eliminate, iar profilul TVirt este înlăturat — dispozitivul în sine rămâne așa cum îl are Linux.',
    nicName: 'Numele dispozitivului',
    nicMac: 'Adresă MAC permanentă',
    nicMacHint: 'MAC-ul hardware permanent — identitatea stabilă fixată de TVirt Server Installer',
    colObserved: 'Observată',
    nicObserved: 'observată',
    nicNotObserved: 'neobservată',
    nicMacMismatch: 'MAC divergent — observat {mac}',
    noNics: 'Nicio NIC înregistrată — înregistrează un dispozitiv ca să începi să-l gestionezi',
    noManagedDevices: 'Niciun dispozitiv gestionat — înregistrează mai întâi o NIC, totul se construiește pe evidență',
    inventoryTitle: 'Dispozitive observate',
    inventorySubtitle: 'Reîmprospătate la fiecare trecere de reconciliere de workerul nodului — validarea verifică numele dispozitivelor pe acest inventar',
    colDevice: 'Dispozitiv',
    colType: 'Tip',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Viteză',
    colTopology: 'Topologie',
    colMtu: 'MTU',
    colAddresses: 'Adrese',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP nu agregă',
    noInventory: 'Niciun dispozitiv raportat până acum',
    interfacesTitle: 'Interfețe',
    interfacesSubtitle:
      'Configurația L3 a NIC-urilor înregistrate și a dispozitivelor logice declarate — set-if înlocuiește întregul bloc, edit-if retușează proprietățile, clear-if îl golește (curățare explicită)',
    colConfig: 'Configurație dorită',
    clean: 'curată',
    setIf: 'Modifică adresarea',
    setIfTitle: 'Modifică adresarea (set-if)',
    editIf: 'Modifică proprietățile',
    editIfTitle: 'Modifică proprietățile (edit-if)',
    clearIf: 'Golește configurația',
    clearIfTitle: 'Golește configurația (clear-if)',
    clearIfConfirm: 'Configurația interfeței este golită. O interfață curată este condiția prealabilă pentru a o înrola ca membru de bond/bridge sau ca părinte de VLAN.',
    ip4Mode: 'Mod IPv4',
    ip6Mode: 'Mod IPv6',
    modeUnconfigured: 'Neconfigurată',
    modeStatic: 'Statică',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Adrese IPv4',
    ip6Addresses: 'Adrese IPv6',
    addressesHint: 'CIDR, separate prin virgulă',
    gw4: 'Gateway IPv4',
    gw6: 'Gateway IPv6',
    dns: 'Servere DNS',
    dnsHint: 'separate prin virgulă — gol șterge DNS-ul (set-if înlocuiește blocul)',
    routes4: 'Rute statice IPv4',
    routes6: 'Rute statice IPv6',
    routeTo: 'Destinație (CIDR)',
    routeVia: 'Via',
    addRoute: 'Adaugă rută',
    routesChip: 'rute',
    mtu: 'MTU',
    mtuHint: 'gol = valoarea implicită a driverului',
    vlansTitle: 'VLAN-uri',
    addVlan: 'Adaugă VLAN',
    addVlanTitle: 'Adaugă VLAN (add-vlan)',
    delVlanTitle: 'Șterge VLAN (del-vlan)',
    vlanParent: 'Interfața părinte',
    vlanId: 'ID VLAN',
    vlanPreview: 'Numele dispozitivului',
    colParent: 'Părinte',
    colVlanId: 'ID',
    noVlans: 'Niciun VLAN declarat',
    bondsTitle: 'Bonduri',
    addBond: 'Adaugă bond',
    addBondTitle: 'Adaugă bond (add-bond)',
    editBondTitle: 'Modifică bondul',
    editBond: 'Salvează bondul',
    delBondTitle: 'Șterge bond (del-bond)',
    bondName: 'Numele bondului',
    members: 'Membri',
    membersHint: 'membrii trebuie să fie interfețe curate (fără configurație L3)',
    bondMode: 'Mod',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Membru primar',
    rate: 'Rate LACP',
    hash: 'Politica de hash la transmisie',
    colMembers: 'Membri',
    colMode: 'Mod',
    noBonds: 'Niciun bond declarat',
    bridgesTitle: 'Bridge-uri',
    addBridge: 'Adaugă bridge',
    addBridgeTitle: 'Adaugă bridge (add-bridge)',
    editBridgeTitle: 'Modifică bridge-ul',
    editBridge: 'Salvează bridge-ul',
    delBridgeTitle: 'Șterge bridge (del-bridge)',
    bridgeName: 'Numele bridge-ului',
    stp: 'STP',
    stpOn: 'STP activ',
    stpOff: 'STP dezactivat',
    colStp: 'STP',
    noBridges: 'Niciun bridge declarat',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Setează hostname-ul',
    setHostnameTitle: 'Setează hostname-ul (set-hostname)',
    hostnameHint: 'Doar identitatea OS — numele nodului în cluster nu este atins',
    notSet: 'nesetat',
    staticHostsTitle: 'Intrări host statice',
    addStaticHost: 'Adaugă intrare',
    addStaticHostTitle: 'Adaugă intrare host statică',
    delStaticHostTitle: 'Șterge intrarea host statică',
    hostIp: 'Adresă IP',
    hostNames: 'Nume',
    hostNamesHint: 'separate prin virgulă sau spațiu',
    colIp: 'IP',
    colNames: 'Nume',
    noStaticHosts: 'Nicio intrare host statică',
    delConfirm: 'Eliminarea lui {name} din documentul dorit — workerul nodului converge cu un checkpoint NetworkManager și rollback automat.',
    remove: 'Elimină',
    opError: 'Operația de rețea a fost refuzată'
  }
}
